import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Tags from '../../components/Tags';

export interface IBlogRollPostItemProps extends IBaseElementProps {
	image?: IImage;
	link?: ILink;
	cta?: ILink;
	tags?: ILink[];
}

/**
 * Blog Roll Post Item
 * @block
 * @requiresHooks
 * @icon media-document
 */
const BlogRollPostItem: React.FC<IBlogRollPostItemProps> = ({
	className,
	classNames = [],
	image,
	link,
	cta,
	tags = [],
}) => (
	<div className={className || cn('blogroll-post-item', ...classNames)}>
		{image && <Image {...image} className="blogroll-post-item__image" />}
		{link && <Button {...link} className="blogroll-post-item__link" />}
		{tags.length > 0 && (
			<Tags tags={tags} className="blogroll-post-item__tags" />
		)}
		{cta && <Button {...cta} className="blogroll-post-item__cta" />}
	</div>
);

export default BlogRollPostItem;
